module.exports = require('next/app')



//////////////////
// WEBPACK FOOTER
// ./node_modules/next/dist/pages/_app.js
// module id = 1181
// module chunks = 22